<template>
  <sg-spacing
    x-xs
    y-xs
    class="fixed left-0 right-0 z-10 w-full transition-transform transform duration-500 ease-in-out"
    :class="[show ? 'translate-y-0' : 'translate-y-40', showingBanner ? 'bottom-16' : 'bottom-0']"
  >
    <div
      class="border border-gray-200 shadow-xl w-full h-20 mt-4 mx-auto flex items-center justify-center bg-white max-w-lg rounded-2xl"
    >
      <sg-text medium regular gray>{{ message }}</sg-text>
    </div>
  </sg-spacing>
</template>

<script>
export default {
  props: {
    showingBanner: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    message() {
      return (
        this.$page.props.flash?.success ||
        this.$page.props.flash?.error ||
        this.$page.props.jetstream.flash?.banner ||
        null
      );
    },
  },

  methods: {
    showToast() {
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 3500);
    },
  },

  mounted() {
    if (this.message) {
      this.showToast();
    }
  },

  watch: {
    '$page.props.flash'(newVal) {
      if (this.message) {
        this.showToast();
      }
    },
  },
};
</script>
